import { render, staticRenderFns } from "./CampaignCheckoutConfirm.vue?vue&type=template&id=ca87d5fa"
import script from "./CampaignCheckoutConfirm.vue?vue&type=script&lang=js"
export * from "./CampaignCheckoutConfirm.vue?vue&type=script&lang=js"
import style0 from "./CampaignCheckoutConfirm.vue?vue&type=style&index=0&id=ca87d5fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports